import { dateRangePickerFields } from "../../filters/components/DateRangePicker";
import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Reference",
    type: FILTER_TYPES.Query,
    fields: "customer_po",
    fetchReportOnEnterPress: true,
  },
  {
    label: "Date",
    type: FILTER_TYPES.DateRange,
    fields: dateRangePickerFields,
    placeholder: "Select Date Range",
  },
  {
    label: "Email",
    type: FILTER_TYPES.Query,
    fields: "email",
    fetchReportOnEnterPress: true,
  },
  {
    label: "Billing Period",
    type: FILTER_TYPES.BillingPeriod,
    fields: "billing_period_name",
  },
  {
    label: "Status",
    type: FILTER_TYPES.Dropdown,
    fields: "charged",
    placeholder: "Select Status",
    options: [
      { value: "", label: "All" },
      { value: "1", label: "Billed" },
      { value: "0", label: "Pending" },
    ],
  },
];
